module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "widget-flash-message"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.responseMessage) ? [(typeof _vm.responseMessage == 'String') ? [_c('div', {
    staticClass: "flash-message message-warning"
  }, [_c('i', {
    staticClass: "icon-error fa fa-warning"
  }), _vm._v("\n        " + _vm._s(_vm.responseMessage) + "\n        "), _c('div', {
    staticClass: "flash-message-close"
  }, [_vm._v("x")])])] : [_c('div', {
    staticClass: "flash-div"
  }, [(_vm.responseMessage && _vm.responseMessage.status == 'success') ? [_c('div', {
    staticClass: "flash-message message-success"
  }, [_c('i', {
    staticClass: "icon-error fa fa-check"
  }), _vm._v("\n            " + _vm._s(_vm.responseMessage.message) + "\n            "), _c('div', {
    staticClass: "flash-message-close"
  }, [_vm._v("x")])])] : _vm._e(), _vm._v(" "), (_vm.responseMessage && _vm.responseMessage.status == 'error') ? [_c('div', {
    staticClass: "flash-message message-error"
  }, [_c('i', {
    staticClass: "icon-error fa fa-times"
  }), _vm._v("\n            " + _vm._s(_vm.responseMessage.message) + "\n            "), _c('div', {
    staticClass: "flash-message-close"
  }, [_vm._v("x")])])] : _vm._e()], 2)]] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ajax-flash-message"
  }, [_c('div', {
    staticClass: "flash-message message-warning"
  }, [_c('i', {
    staticClass: "icon-error fa fa-warning"
  }), _vm._v(" "), _c('span', {
    staticClass: "flash-message-text"
  }), _vm._v(" "), _c('div', {
    staticClass: "flash-message-close"
  }, [_vm._v("x")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d7075ede!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dash/widgets/WidgetFlashMessage.vue
// module id = 3989
// module chunks = 1